import CircularProgress from '@mui/material/CircularProgress'

interface Props {
  size?: number
}

export const Loader = ({ size }: Props) => {
  return (
    <div style={{ padding: 24, display: 'flex', width: '100%', justifyContent: 'center' }}>
      <CircularProgress size={size ?? 40} color="primary" />
    </div>
  )
}
